module.exports = __webpack_public_path__ + "static/media/arrow-right.26f92e3a.svg";